import { CharacterAttackCharge } from './CharacterAttackCharge';
import { CharacterAttack, CharacterAttackFaked } from './CharacterAttack';
import { CharacterAttackThrow } from './CharacterAttackThrow';
import { GunbotLaserBolt } from './GunbotLaserBolt';
import { AttackRobinSpecialForward } from './AttackRobinSpecialForward';
import { AttackBeastboySpecialForward } from './AttackBeastboySpecialForward';
import { AttackBeastboySpecialStanding } from './AttackBeastboySpecialStanding';
import { AttackCyborgSpecialStanding } from './AttackCyborgSpecialStanding';
import { AttackStarfireSpecialForward } from './AttackStarfireSpecialForward';
import { AttackRavenSpecialStanding } from './AttackRavenSpecialStanding';

const AttackFactoryMap = {
  laserbolt: GunbotLaserBolt,
  charge: CharacterAttackCharge,
  throw: CharacterAttackThrow,
  robinspecialforward: AttackRobinSpecialForward,
  beastboyspecialforward: AttackBeastboySpecialForward,
  beastboyspecialstanding: AttackBeastboySpecialStanding,
  cyrborgspecialstanding: AttackCyborgSpecialStanding,
  starfirespecialforward: AttackStarfireSpecialForward,
  ravenspecialstanding: AttackRavenSpecialStanding,
};

export const CharacterAttackFactory = {
  create: (scene, character, config) => {
    if (AttackFactoryMap[config.name]) {
      return new AttackFactoryMap[config.name](scene, character, config);
    }
    if (AttackFactoryMap[config.class]) {
      return new AttackFactoryMap[config.class](scene, character, config);
    }
    if (character.spriteHasAnimation(config.animation)) {
      return new CharacterAttack(scene, character, config);
    }
    return new CharacterAttackFaked(scene, character, config);
  },
};
